import { ComponentType } from 'react';
import { AnySchema } from 'yup';
import { DeclarationCountry } from 'store/declarations/enums/common/declaration-country';
import { DeclarationInternalType } from 'store/declarations/enums/common/declaration-internal-type';
import { AISMessageTypes, MessageTypes } from 'store/declarations/enums/common/declaration-types';
import { ValidationSchema } from 'views/declarations/uk/export/validations/validations';
import {
    irelandH1ColumnErrorPaths,
    irelandH1FieldChecklist,
    irelandH1ItemFieldsRegistry,
} from './irelandH1ItemFieldsRegistry';

// Keyed by the same column `key`s the item errors table (per declaration type) produces, so a
// column error can be resolved directly to the form field that fixes it.
export type ItemFieldEntry = {
    Component: ComponentType<any>;
    props?: Record<string, any>;
    // UK's custom validation framework for CDS declarations, or a Yup schema for AIS declarations.
    validationSchema: ValidationSchema | AnySchema;
};

export type ItemFieldsRegistry = Partial<Record<string, ItemFieldEntry>>;

export const getItemFieldsRegistry = (
    country?: DeclarationCountry,
    internalType?: DeclarationInternalType,
    messageType?: MessageTypes
): ItemFieldsRegistry => {
    if (
        country === DeclarationCountry.IRELAND &&
        internalType === DeclarationInternalType.IMPORT &&
        messageType === AISMessageTypes.H1
    ) {
        return irelandH1ItemFieldsRegistry;
    }

    // Note: Add registries for other declaration types as their "fix missing field" forms are built.
    return {};
};

// The validation error path(s) (relative to a single flattened item) that each registry/table
// column key represents - used both for highlighting table cells and for deciding which fields
// to show in the "fix missing field" modal.
export const getColumnErrorPaths = (
    country?: DeclarationCountry,
    internalType?: DeclarationInternalType,
    messageType?: MessageTypes
): Record<string, string[]> => {
    if (
        country === DeclarationCountry.IRELAND &&
        internalType === DeclarationInternalType.IMPORT &&
        messageType === AISMessageTypes.H1
    ) {
        return irelandH1ColumnErrorPaths;
    }

    return {};
};

// The flat list of individual fields to check in the progress sidebar - one entry per field,
// so e.g. net and gross mass are tracked (and shown) separately rather than as one combined check.
export const getFieldChecklist = (
    country?: DeclarationCountry,
    internalType?: DeclarationInternalType,
    messageType?: MessageTypes
): { path: string; label: string }[] => {
    if (
        country === DeclarationCountry.IRELAND &&
        internalType === DeclarationInternalType.IMPORT &&
        messageType === AISMessageTypes.H1
    ) {
        return irelandH1FieldChecklist;
    }

    return [];
};
